// extracted by mini-css-extract-plugin
export default {"container":"SyncFromCrmConfirmationDialog_container__Ydlix","text":"SyncFromCrmConfirmationDialog_text__rOL7f"};